export const Button = ({ onClick, className, children, isDisabled }) => {
  return (
    <button disabled={isDisabled} onClick={onClick} className={"bg-[#a0214e] text-white p-2 " + className}>
      {children}
    </button>
  );
};
